import React, { useState, useEffect } from "react";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { motion } from "framer-motion";
import { IoClose } from "react-icons/io5";
import { FaCheck } from "react-icons/fa6";
import { post, people } from "../../config/imagesLink";
import { useTranslation } from "react-i18next";

const UserAuth = ({
  setShowUserAuthModal,
  onClose,
  data,
  showUserAuthModal,
  fetchData,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation()
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [topUsers, setTopUsers] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [step, setStep] = useState(1);

  //dob
  const [startDate, setStartDate] = useState(null);
  const language = localStorage.getItem("Lang");

  //city
  const [cityData, setCityData] = useState([]);

  const [citySearch, setCitySearch] = useState("");
  const [cityId, setCityId] = useState(null);

  //gender
  const [genderOptionList, setGenderOptionList] = useState([]);
  const [selectedGender, setSelectedGender] = useState("");
  const [display, setDisplay] = useState(false);


  const getTopUsersAndCompanies = async () => {
    setIsLoading(true);

    const data = {
      deviceType: "Web",
      pageNumber: 1,
      pageSize: 24,
    };

    try {
      const [usersResponse, companiesResponse] = await Promise.all([
        axios.post("UserProfile/GetAllUserList", data),
        axios.post("Company/GetAllCompaniesList", data),
      ]);

      const users = usersResponse.data.responseData.userList || [];
      const companies = companiesResponse.data.responseData.companiesList || [];

      setTopUsers(users);
      setCompanyList(companies);
    } catch (error) {
      console.error("Error fetching top users or companies:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTopUsersAndCompanies();
  }, []);

  const handleUserSelection = (userUid) => {
    setSelectedUsers((prevSelected) =>
      prevSelected.includes(userUid)
        ? prevSelected.filter((uid) => uid !== userUid)
        : [...prevSelected, userUid]
    );
  };

  const handleCompanySelection = (compUid) => {
    setSelectedCompanies((prevSelected) =>
      prevSelected.includes(compUid)
        ? prevSelected.filter((uid) => uid !== compUid)
        : [...prevSelected, compUid]
    );
  };

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  //Profile Information
  const getCity = () => {
    // if (!inputValue) return;
    axios
      // .get(`Master/GetCitiesDDL?search=${inputValue}?LangKey=${language}`)
      // .get(`Master/GetCitiesDDL?search=${citySearch}?LangKey=${language}`)

      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log("Error fetching cities:", error);
      });
  };


  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);

  const getGenderData = async () => {
    try {
      const response = await axios.get(`/Master/GetGenderDDL?LangKey=${language}`);
      setGenderOptionList(response.data.responseData || []);
    } catch (error) {
      console.error("Error fetching gender data:", error);
    }
  };

  const genderOptions = genderOptionList.map((val) => ({
    value: val.gndrId,
    label: val.name,
  }));

  const selectGender = (selectedOption) => {
    setSelectedGender(selectedOption?.value || "");
  };

  useEffect(() => {
    getGenderData();
  }, []);

  const preventYearScroll = (instance) => {
    setTimeout(() => {
      if (instance.calendarContainer) {
        const yearSelect =
          instance.calendarContainer.querySelector(".numInput");
        if (yearSelect) {
          yearSelect.setAttribute("disabled", "true");
        }
      }
    }, 10);
  };

  const submitProfileCompletion = async () => {
    setDisplay(true)
    if (!startDate || !selectedGender || !cityId) {
      setWarningToastMessage("Please fill in all required fields.");
      setShowWarningToast(true);
      return;
    }

    try {
      const requestData = {
        deviceType: "Web",
        sessionId: sessionId,
        userUIDs: selectedUsers,
        companyUIDs: selectedCompanies,
        dob: startDate ? startDate.toISOString().split("T")[0] : null,
        genderID: selectedGender,
        cityID: cityId,
        langKey: language === "en" ? "" : language,
      };
      console.log(requestData);
      const response = await axios.post(
        "/Feature/OnboardProfileCompletion",
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setToastMessage(t("Common.ProfileUpdated"));
      setShowToast(true);
      setTimeout(() => {
        onClose(true);
        setShowUserAuthModal(false);
      }, 2000);
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage("404 Error");
        setShowWarningToast(true);
        console.log(e);
      } else {
        setErrorToastMessage("Something Went Wrong");
        setShowErrorToast(true);
        console.log(e);
      }
    }
  };

  return (
    <>
      {showUserAuthModal && (
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{ zIndex: 1050 }}
        >
          <div className="modal-container userauth">
            <div className="modal-header-container">
              <div className="modal-header d-flex  flex-column align-items-center justify-content-center">
                <span className="check-icon me-3">
                  <FaCheck />
                </span>
                <div className="text-center">
                  {step === 1 && <h2>Follow Top Users</h2>}
                  {step === 2 && <h2>Follow Top Job Companies around you</h2>}
                  {step === 3 && <h2>Complete Your Profile</h2>}
                  <p className="text-center">
                    {step === 1 && "Choose top users to follow."}
                    {step === 2 && "Follow the companies for job opening."}
                    {step === 3 && "Complete your profile details"}
                  </p>
                </div>
              </div>
            </div>
            <button className="btn-close UserAuthCloseBtn mt-2" onClick={onClose}>
              {/* <IoClose /> */}
            </button>

            {/* Steps */}
            <div className="content-section mt-1">
              {step === 1 && (
                <div
                  className="row"
                  style={{
                    maxHeight: "370px",
                    overflowY: "auto",
                    padding: "2% calc(4% + 6px)",
                    width: "100%",
                    maxWidth: "100%",
                  }}
                >
                  {/* {topUsers?.length > 0 &&
                    topUsers?.map((user) => {
                      const isSelected = selectedUsers.includes(user.userUid);
                      return (
                        <div
                          key={user.userUid}
                          className={`col-xl-4 col-md-6 p-1 position-relative`}
                          onClick={() => handleUserSelection(user.userUid)}
                        >
                          <div
                            className="user-onboarding-card d-flex align-items-center position-relative cursor-pointer"
                            style={{
                              position: "relative",
                              padding: "10px",
                              overflow: "hidden",
                            }}
                          >
                            {isSelected && (
                              <div
                                className="position-absolute w-100 h-100"
                                style={{
                                  backgroundColor: "rgba(1, 30, 73, 0.2)",
                                  top: 0,
                                  left: 0,
                                }}
                              ></div>
                            )}

                            <div>
                              <figure className="top-users">
                                <img
                                  src={user.profilPic}
                                  alt={user.name}
                                  className="w-100 h-100 object-fit-cover"
                                />
                              </figure>
                            </div>

                            <div className="d-flex flex-column justify-content-center position-relative">
                              <span className="d-flex align-items-center gap-2">
                                {user.fullName.split(" ").slice(0, 2).join(" ")}
                              </span>
                              <span>{user.nameTag}</span>
                              <span>Followers: {user.follwersCounts}</span>
                            </div>

                            <div className="right-tick">
                              {isSelected && (
                                <FaCheck
                                  style={{
                                    fontSize: "24px",
                                    padding: "6px",
                                    color: "#fff",
                                    backgroundColor: "#011E49",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })} */}
                  {loading ? (
                    <div className="text-center w-100 py-4">
                      <div className="text-center my-3">
                        <img src={post?.loader} width={50} />
                      </div>
                    </div>
                  ) : topUsers?.length > 0 ? (
                    topUsers.map((user) => {
                      const isSelected = selectedUsers.includes(user.userUid);
                      return (
                        <div
                          key={user.userUid}
                          className="col-xl-4 col-md-6 p-1 position-relative"
                          onClick={() => handleUserSelection(user.userUid)}
                        >
                          <div
                            className="user-onboarding-card d-flex align-items-center position-relative cursor-pointer"
                            style={{
                              position: "relative",
                              padding: "10px",
                              overflow: "hidden",
                            }}
                          >
                            {isSelected && (
                              <div
                                className="position-absolute w-100 h-100"
                                style={{
                                  backgroundColor: "rgba(1, 30, 73, 0.2)",
                                  top: 0,
                                  left: 0,
                                }}
                              ></div>
                            )}

                            <div>
                              <figure className="top-users">
                                <img
                                  src={user.profilPic || people.DefaultProfile}
                                  alt={user.name}
                                  className="w-100 h-100 object-fit-cover"
                                  onError={handleProfileImageError}
                                />
                              </figure>
                            </div>

                            <div className="d-flex flex-column justify-content-center position-relative">
                              <span className="d-flex align-items-center gap-2">
                                {user.fullName.split(" ").slice(0, 2).join(" ")}
                              </span>
                              <span>{user.nameTag}</span>
                              <span>Followers: {user.follwersCounts}</span>
                            </div>

                            <div className="right-tick">
                              {isSelected && (
                                <FaCheck
                                  style={{
                                    fontSize: "24px",
                                    padding: "6px",
                                    color: "#fff",
                                    backgroundColor: "#011E49",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    ""
                  )}
                </div>
              )}

              {step === 2 && (
                <div
                  className="row"
                  style={{
                    maxHeight: "370px",
                    overflowY: "auto",
                    padding: "2% 4%",
                    width: "100%",
                    maxWidth: "100%",
                  }}
                >
                  {companyList?.length > 0 &&
                    companyList?.map((company) => {
                      const isSelected = selectedCompanies.includes(
                        company.compUid
                      );
                      return (
                        <div
                          key={company.compUid}
                          className="col-xl-4 col-md-6 p-1 position-relative"
                          onClick={() =>
                            handleCompanySelection(company.compUid)
                          }
                        >
                          <div
                            className={`user-onboarding-card d-flex align-items-center position-relative cursor-pointer ${isSelected ? "border border-success" : ""
                              }`}
                            style={{
                              position: "relative",
                              padding: "10px",
                              overflow: "hidden",
                            }}
                          >
                            {isSelected && (
                              <div
                                className="position-absolute w-100 h-100"
                                style={{
                                  backgroundColor: "rgba(1, 30, 73, 0.2)",
                                  top: 0,
                                  left: 0,
                                }}
                              ></div>
                            )}

                            <div>
                              <figure className="top-users">
                                <img
                                  src={
                                    company?.logoImage || "fallback-image.jpg"
                                  }
                                  alt={company.companyName}
                                  className="w-100 h-100 object-fit-cover"
                                />
                              </figure>
                            </div>

                            <div className="d-flex flex-column justify-content-center position-relative">
                              <span className="d-flex align-items-center gap-2">
                                {company.compName
                                  .split(" ")
                                  .slice(0, 2)
                                  .join(" ")}
                              </span>
                              <span>Followers: {company.follwersCounts}</span>
                            </div>

                            <div className="right-tick">
                              {isSelected && (
                                <FaCheck
                                  style={{
                                    fontSize: "24px",
                                    padding: "6px",
                                    color: "#fff",
                                    backgroundColor: "#011E49",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}

              {step === 3 && (
                <div
                  className="px-3 pb-2 LastSectionCompleteProfile"
                  style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    padding: "2% 10%",
                  }}
                >
                  <div className="mb-3">
                    <label className="form-label">DOB<span className="text-danger ms-2">*</span></label>
                    <Flatpickr
                      className="form-control ps-2 pt-2"
                      value={startDate}
                      onChange={(date) => setStartDate(date[0])}
                      id="dob"
                      options={{
                        maxDate: "today",
                        dateFormat: "Y-m-d",
                        allowInput: true,
                        onReady: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance);
                        },
                        onOpen: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance);
                        },
                      }}
                      placeholder="Enter your DOB"
                      required
                    />
                    {display && !startDate ? (
                      <span className="error_msg_lbl">
                        DOB is required
                      </span>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Gender<span className="text-danger ms-2">*</span></label>
                    <Select
                      options={genderOptions}
                      value={genderOptions.find(
                        (option) => option.value === selectedGender
                      )}
                      onChange={selectGender}
                      className="react-select-container Gender-selectField"
                      classNamePrefix="react-select"
                      isSearchable={false}
                      placeholder={t("Newsfeed.Select Gender")}
                      menuPortalTarget={document.body}  // 👈 render outside modal
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // keep it above modal
                        menu: (base) => ({
                          ...base,
                          position: "absolute",
                          zIndex: 9999,
                          backgroundColor: "white",
                        }),
                      }}
                    />
                    {display && !selectedGender ? (
                      <span className="error_msg_lbl">
                        Gender is required
                      </span>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">City<span className="text-danger ms-2">*</span></label>
                    <Select
                      defaultValue={cityId}
                      onChange={(selectedOption) =>
                        setCityId(selectedOption.value)
                      }
                      options={cityData}
                      noOptionsMessage={() => t("modals.Search and Select City")}
                      placeholder={t("modals.Search and Select City")}
                      className="Gender-selectField"
                      onInputChange={(inputValue) => {
                        setCitySearch(inputValue);

                      }}
                      invalid={display && cityId === ""}


                      // options={cityData}
                      // onInputChange={getCity}
                      // onChange={(selected) =>
                      // setCityId(selected ? selected.value : null)
                      // }
                      // placeholder="Select a City"
                      // noOptionsMessage={() => "Search and Select a City"}
                      // isSearchable
                      menuPortalTarget={document.body}  // render outside modal
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // keep it above modal
                        menu: (base) => ({
                          ...base,
                          position: "absolute",
                          zIndex: 9999,
                          backgroundColor: "white",
                        }),
                      }}
                    />
                    {display && !cityId ? (
                      <span className="error_msg_lbl">
                        City is required
                      </span>
                    ) : null}
                  </div>
                </div>
              )}
            </div>

            {/* Progress Bar and button */}
            <div className="borderbottomUserAuth user-onboarding-footer d-flex justify-content-between align-items-center w-100 p-3">
              <div className="col-5">
                <div className="progress w-100">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${(step / 3) * 100}%` }}
                  ></div>
                </div>
                <p className="text-start mt-2">
                  Great Job! You can add more or explore sources.
                </p>
              </div>
              <div className="d-flex align-items-center gap-2">
                {step > 1 && (
                  <div className="d-flex">
                    <div>
                      {/* <button
                        className="mainBtn ms-2"
                        // onClick={() => setStep(step + 1)}
                        onClick={() => {
                          // submitProfileCompletion();
                          setStep((prev) => Math.min(prev + 1, 3));
                        }}
                      // disabled={selectedUsers.length === 0}
                      >
                        Skip
                      </button> */}
                      {step !== 3 && (
                        <span
                          className="skipBtn me-2"
                          onClick={() => {
                            setStep((prev) => Math.min(prev + 1, 3));
                          }}
                        >
                          Skip
                        </span>
                      )}
                    </div>
                    <div>
                      <button
                        className="mainBtn "
                        onClick={() => setStep(step - 1)}
                      >
                        Back
                      </button>
                    </div>

                  </div>
                )}
                {step == 1 && (
                  <div className="d-flex ">
                    <div>
                      {/* <button
                        className="mainBtn"
                        onClick={() => setStep(step + 1)}
                      // disabled={selectedUsers.length === 0}
                      >
                        Skip
                      </button> */}
                      <span
                        className="skipBtn"
                        onClick={() => {
                          setStep(step + 1);
                        }}
                      >
                        Skip
                      </span>
                    </div>
                    <div>
                      <button
                        className="mainBtn ms-2"
                        onClick={() => setStep(step + 1)}
                        disabled={selectedUsers.length === 0}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
                {step == 2 && (
                  <button
                    className="mainBtn "
                    onClick={() => setStep(step + 1)}
                    disabled={selectedCompanies.length === 0}
                  >
                    Next
                  </button>
                )}
                {step === 3 && (
                  <button
                    className="mainBtn"
                    onClick={() => {
                      submitProfileCompletion();
                      setStep((prev) => Math.min(prev + 1, 3));
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>
        </motion.div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default UserAuth;
